import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Transport } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { TransportListIconNameMap } from 'src/app/pages/custom-route/interfaces/custom-route.response';
import { TimelineStatus } from 'src/app/pages/custom-route/shared/planner/components/route-timeline/interfaces';
import { PointListLineComponent } from "./components/point-list-line/point-list-line.component";
import { LineComponent } from "./components/line/line.component";
import { TransportIconComponent } from "./components/transport-icon/transport-icon.component";
import { TransportNameComponent } from "./components/transport-name/transport-name.component";
import { DurationComponent } from "./components/duration/duration.component";
import { StopDetailsComponent } from "./components/stop-details/stop-details.component";

@Component({
  selector: 'app-transport-list-card-standard-transfer',
  standalone: true,
  imports: [
    TranslateModule,
    PointListLineComponent,
    LineComponent,
    TransportIconComponent,
    TransportNameComponent,
    DurationComponent,
    StopDetailsComponent
],
  templateUrl: './transport-list-card-standard-transfer.component.html',
  styleUrls: ['./transport-list-card-standard-transfer.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TransportListCardStandardTransferComponent {
  public lineHeight = input.required<number>();
  public transportList = input.required<Transport[]>();
  public transport = input.required<Transport>();
  public pointTitle = input.required<string>();
  public previousPointTitle = input.required<string>();
  public status = input.required<TimelineStatus>();
  
  public walkTransferType = TransportListIconNameMap.walk;
}
